import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { DeliberyNoteCreateFotoPage } from '../../../delibery_note/delibery-note-create/delibery-note-create-foto/delibery-note-create-foto';



/**
 * Generated class for the PhotoDishPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'photo-albaran',
  templateUrl: 'photo-albaran.html',
})
export class PhotoAlbaranPage {
  @Input() photo_width: string;
  @Input() photo_height: string;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public DeliberyNoteCreateFotoPage: DeliberyNoteCreateFotoPage,
    public globals: Globals) {
  }


  stylePhoto() {
    let styles = {
      'width': this.photo_width,
      'height': this.photo_height,
      'object-fit': 'cover'
    };
    return styles;
  }

  styleNoPhoto() {
    let styles = {
      'width': this.photo_width,
      'height': this.photo_height,
      'object-fit': 'contain'
    };
    return styles;
  }


}



// WEBPACK FOOTER //
// ./src/pages/components/photo/photo-albaran/photo-albaran.ts